module.exports = __webpack_public_path__ + "fonts/font.b633ffff.woff";